export function isCancelledBooking(booking) {
  return ['cancelled', 'canceled'].includes(String(booking?.status || '').toLowerCase());
}

export function bookingAttendanceValue(booking) {
  return typeof booking?.participated === 'boolean' ? booking.participated : null;
}

function searchable(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
}

function validDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return '';
  const parsed = new Date(`${value}T12:00:00Z`);
  return Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== value ? '' : value;
}

export function selectTimelineBookings(bookings, filters = {}) {
  const search = searchable(filters.search);
  const phoneSearch = search.replace(/[^\d]/g, '');
  const searchIsPhone = !!phoneSearch && /^[+\d\s().-]+$/.test(search);
  const direction = filters.order === 'asc' ? 1 : -1;
  return bookings.filter(booking => {
    const date = validDate(booking.dateKey);
    if (filters.from && (!date || date < filters.from)) return false;
    if (filters.to && (!date || date > filters.to)) return false;
    const participated = bookingAttendanceValue(booking);
    if (filters.attendance === 'yes' && participated !== true) return false;
    if (filters.attendance === 'no' && participated !== false) return false;
    if (filters.attendance === 'unreviewed' && participated !== null) return false;
    if (search && !searchable(`${booking.fullName || ''} ${booking.email || ''} ${booking.phone || ''}`).includes(search)) {
      if (!searchIsPhone || !String(booking.phone || '').replace(/[^\d]/g, '').includes(phoneSearch)) return false;
    }
    return true;
  }).sort((a, b) => {
    const aDate = validDate(a.dateKey);
    const bDate = validDate(b.dateKey);
    // Undated records remain reachable at the end in either direction.
    if (!aDate && bDate) return 1;
    if (aDate && !bDate) return -1;
    const dates = aDate.localeCompare(bDate);
    const times = String(a.timeKey || '').localeCompare(String(b.timeKey || ''));
    return (dates || times) * direction || String(a.id || '').localeCompare(String(b.id || ''));
  });
}
